/*
 * HOW MANY PAGE SLOTS THE GRID HAS (14, 2026-10-25; was 12). The one number every other index is derived from: the page slots are 0 to PAGE_SLOT_COUNT - 1, "All other pages" is the box after them, then the
 * historical dock, then the collapsed cluster. It mirrors the backend's MAX_PAGE_SLOT_INDEX (SiteApi/Helper/reorderMoves.ts, one less) and the plans' `mainViewSlots` (SubscriptionApi/Constant/subscriptions.const.ts):
 * change all three together. See docs/SLOTS_14_IMPLEMENTATION.md.
 */
export const PAGE_SLOT_COUNT = 14;
